import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initSentry } from './lib/sentry';
import { hydrateMemedPublicEnv } from './integrations/memed/memed.config';
import { hydrateLandingStoreEnv } from './constants/landing.constants';
import './app/globals.css';

hydrateMemedPublicEnv({
  VITE_MEMED_ENABLED: import.meta.env.VITE_MEMED_ENABLED,
  VITE_MEMED_SCRIPT_URL: import.meta.env.VITE_MEMED_SCRIPT_URL,
  VITE_MEMED_CERTIFICATE_EXAM_ENABLED: import.meta.env.VITE_MEMED_CERTIFICATE_EXAM_ENABLED,
});

hydrateLandingStoreEnv({
  VITE_PLAY_STORE_URL: import.meta.env.VITE_PLAY_STORE_URL,
  VITE_APP_STORE_URL: import.meta.env.VITE_APP_STORE_URL,
});

initSentry();

console.log('🚀 Main.tsx carregado');

// Log global para todos os erros
window.addEventListener('error', (event) => {
  console.error('🔴 ERRO GLOBAL:', event.error);
  const loadingDiv = document.getElementById('loading');
  if (loadingDiv) {
    loadingDiv.innerHTML = `
      <div style="text-align: center;">
        <div style="font-size: 48px; margin-bottom: 20px; color: #d32f2f;">❌</div>
        <p style="font-size: 18px; color: #d32f2f;"><strong>Erro na Aplicação</strong></p>
        <pre style="background: #f5f5f5; padding: 10px; border-radius: 4px; margin-top: 10px; text-align: left; font-size: 12px; color: #333; max-width: 500px;">
${event.error?.message || 'Erro desconhecido'}
        </pre>
        <p style="font-size: 12px; color: #999; margin-top: 10px;">Abra o console (F12) para mais detalhes</p>
      </div>
    `;
  }
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('🔴 UNHANDLED REJECTION:', event.reason);
  const loadingDiv = document.getElementById('loading');
  if (loadingDiv) {
    loadingDiv.innerHTML = `
      <div style="text-align: center;">
        <div style="font-size: 48px; margin-bottom: 20px; color: #d32f2f;">❌</div>
        <p style="font-size: 18px; color: #d32f2f;"><strong>Rejeição Não Tratada</strong></p>
        <pre style="background: #f5f5f5; padding: 10px; border-radius: 4px; margin-top: 10px; text-align: left; font-size: 12px; color: #333; max-width: 500px;">
${event.reason?.message || event.reason || 'Erro desconhecido'}
        </pre>
        <p style="font-size: 12px; color: #999; margin-top: 10px;">Abra o console (F12) para mais detalhes</p>
      </div>
    `;
  }
});

const root = document.getElementById('root');
if (!root) {
  console.error('❌ Elemento #root não encontrado no HTML');
  document.body.innerHTML = `
    <div style="padding: 20px; font-family: system-ui; color: #d32f2f;">
      <h1>❌ Erro Fatal</h1>
      <p>Elemento #root não encontrado no HTML!</p>
      <p>Verifique o arquivo index.html</p>
    </div>
  `;
  throw new Error('Elemento #root não encontrado');
}

console.log('✅ Elemento #root encontrado');

try {
  const rootElement = ReactDOM.createRoot(root);
  console.log('✅ ReactDOM.createRoot criado');

  rootElement.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>,
  );

  console.log('✅ Aplicação renderizada com sucesso');
  
  // Remove loading indicator quando app renderiza
  setTimeout(() => {
    const loading = document.getElementById('loading');
    if (loading) {
      loading.style.display = 'none';
      console.log('✅ Loading indicator removido');
    }
  }, 100);
} catch (error) {
  console.error('❌ Erro ao renderizar aplicação:', error);
  const loadingDiv = document.getElementById('loading');
  if (loadingDiv) {
    loadingDiv.innerHTML = `
      <div style="text-align: center;">
        <div style="font-size: 48px; margin-bottom: 20px; color: #d32f2f;">❌</div>
        <h1 style="color: #d32f2f; margin-top: 0;">Erro ao Renderizar</h1>
        <pre style="background: #f5f5f5; padding: 10px; border-radius: 4px; text-align: left; font-size: 12px; color: #333; max-width: 500px;">
${error}
        </pre>
        <p style="font-size: 12px; color: #999; margin-top: 10px;">Abra o console (F12) para mais detalhes</p>
      </div>
    `;
  }
}

